(ns hai.admin-ui.data-tasks.helpers
  (:require
   [hai.ui.icons :as icons]
   [hai.ui.tokens :as t]))

(def ->label :task/title)

(defn ->icon
  [_task]
  icons/humble-task)

(defn ->tint
  [_]
  t/--tasks)
